/* eslint-disable import/no-cycle */
import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { fetchBanks } from 'actions/cms/banks'
import Icon, { IconNames } from 'components/icons'
import CONFIG from 'config'
import { isEmpty } from 'helpers/utils'
import { getBanks } from 'selectors/cms/banks'
import theme from 'styles/theme'

import {
  Arrow,
  BackgroundContainer,
  Card,
  CardContainer,
  Container,
  Image,
  LinkTag,
  Title,
  Wrapper
} from './styled'

const BanksSlider = props => {
  const { banks } = props
  const { t } = useTranslation()

  const [activeSlides, setActiveSlides] = useState([0])

  React.useEffect(() => {
    isEmpty(props.banks) && props.fetchBanks()
  }, [])

  const customArrow = name => (
    <Arrow>
      <Icon name={name} color={theme.colors.blue} size={23} />
    </Arrow>
  )

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
    nextArrow: customArrow(IconNames.ChevronRight),
    prevArrow: customArrow(IconNames.ChevronLeft),
    beforeChange: (_, next) => setActiveSlides([...activeSlides, next]),
    afterChange: currentSlide => setActiveSlides([currentSlide]),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  }

  if (!isEmpty(banks.cards)) {
    return (
      <BackgroundContainer>
        <Container>
          <Title>{t('general.footer.best-financing')}</Title>
          {banks.highlighted && (
            <Card highlighted url={banks.highlighted.bankfUrl} dataPosition={1}>
              <Image
                src={`${CONFIG.CONTENT_CDN_BASE_URL}${banks.highlighted.bankfLogo}`}
                alt={banks.highlighted.bankfAltText || ''}
              />
            </Card>
          )}
          <Wrapper cards={banks.cards.length} hasHighlighted={banks.highlighted}>
            <Slider {...settings}>
              {banks.cards
                .filter(({ id }) => id !== (banks.highlighted && banks.highlighted.nid))
                .map((item, index) => (
                  <CardContainer key={index}>
                    <Card
                      title={`${item.alt || 'bank'} ${index}`}
                      url={item.url}
                      aria-roledescription="slide"
                      tabIndex={props.isMobile && !activeSlides.includes(index) ? -1 : 0}
                      dataPosition={index + 2}
                    >
                      <Image src={item.logo} alt={item.alt || ''} />
                    </Card>
                  </CardContainer>
                ))}
            </Slider>
          </Wrapper>
          <LinkTag dangerouslySetInnerHTML={{ __html: t('general.footer.see-more-banks') }} />
        </Container>
      </BackgroundContainer>
    )
  }
  return null
}

const mapStateToProps = state => ({
  banks: getBanks(state)
})

const mapDispatchToProps = {
  fetchBanks
}

export default connect(mapStateToProps, mapDispatchToProps)(BanksSlider)
